export class Country {
    public id: number = 0;
    public code: string = '';
    public name: string = '';

    public constructor(obj?: Partial<Country>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
